import { SupplierInfo } from "@bundles/parts/data/model"

export const createAddress = (supplierInfo: SupplierInfo | undefined, translateText: (key: number | string) => string) => {
    if (!supplierInfo) {
        return null
    }

    const address = []
    supplierInfo.description && address.push({ label: translateText(108), value: supplierInfo.description }) // Company
    supplierInfo.street && address.push({ label: translateText(3151), value: supplierInfo.street }) // Street
    supplierInfo.postbox && address.push({ label: translateText(14067), value: supplierInfo.postbox }) // PO box
    supplierInfo.countryCode && address.push({ label: translateText(114), value: supplierInfo.countryCode }) // Land
    supplierInfo.city && address.push({ label: translateText(113), value: supplierInfo.city }) // City
    supplierInfo.zip && address.push({ label: translateText(112), value: supplierInfo.zip }) // Postcode
    supplierInfo.eMail && address.push({ label: translateText(109), value: supplierInfo.eMail }) // Email
    supplierInfo.url && address.push({ label: translateText(822), value: supplierInfo.url }) // Website

    return address
}
